import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import userSelectedComponentSlice from './slices/userSelectedComponentSlice';
import onboardingReducer from './slices/onboardingSlice';
import { shouldExposePlaywrightHooks } from '@/utils/playwrightHooks';

export const store = configureStore({
  reducer: {
    userSelectedComponentSlice,
    onboarding: onboardingReducer,
  },
});

/** Expose the store for Playwright (dev, VITE_E2E_HOOKS, or runtime init-script flag). */
if (shouldExposePlaywrightHooks()) {
  (
    window as unknown as { __QTRACE_STORE__?: typeof store }
  ).__QTRACE_STORE__ = store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
